import { addModel, allModels, deleteModel, updateModel } from '@/utils/request'
import vue from '@/main'

const state = {
  modelList: []
}

const mutations = {
  RESET (state) {
    state.modelList = []
  }
}

const actions = {
  all ({ state }) {
    return new Promise((resolve) => {
      allModels().then(response => {
        state.modelList = response.data
        resolve(state.modelList)
      })
    })
  },
  modelById ({ commit, state }, id) {
    for (const team of state.modelList) {
      if (team.id === id) return vue.$_.cloneDeep(team)
    }
    return null
  },
  updateOne ({ state }, model) {
    return new Promise((resolve) => {
      updateModel(model).then(() => {
        for (const cur of state.modelList) {
          if (cur.id === model.id) {
            Object.assign(cur, model)
            break
          }
        }
        this.dispatch('data/kvListForce', 'BrandModel')
        resolve()
      })
    })
  },
  add ({ commit, dispatch, state }, team) {
    return new Promise((resolve) => {
      addModel(team).then((response) => {
        state.modelList.push(response.data)
        this.dispatch('data/kvListForce', 'BrandModel')
        resolve(response.data)
      })
    })
  },
  delete ({ commit, dispatch, state }, model) {
    return new Promise((resolve) => {
      deleteModel(model.id).then(() => {
        for (const i in state.modelList) {
          if (state.modelList[i].id === model.id) {
            state.modelList.splice(i, 1)
          }
        }
        this.dispatch('data/kvListForce', 'BrandModel')
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
